module.exports = __webpack_public_path__ + "static/img/14.90a4da0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/sp/14.png
// module id = vzvQ
// module chunks = 0